var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail align-items-center justify-content-center mr-16"},[(_vm.typeNm === 'FOLDER')?_c('svg-folder'):_c('img',{attrs:{"src":"https://via.placeholder.com/40?text=%20","alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }